import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class GetCategoryImageList extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Gallery API
                </h1>
                    <div>
                        <h2 className="main-subheading">
                            pcs.get_category_image_list</h2>
                        <div className="technical-main-content">
                            <p>
                                Lists the images available within a single category. The image tags are returned
                                in order defined using Image Management within Administration.
                        </p>
                            <div>
                                <h3>
                                    Arguments</h3>
                                <ul>
                                    <li><b>api_key</b> (Required)
                                    <p>
                                            A valid API key that must be obtained from Thales representing a subscriber/product
                                            combination. This will be the product handover key and is used to determine which
                                        category list to return.</p>
                                    </li>
                                    <li><b>method</b> (Required)
                                    <p>
                                            pcs.get_category_image_list</p>
                                    </li>
                                    <li><b>category_id</b>
                                        <p>
                                            The ID value returned from the ‘category’ tag in the get_category_list call</p>
                                    </li>
                                    <li><b>page_num</b> (optional)
                                    <p>
                                            The number of the page. If not specified, this defaults to 1. The minimum value
                                        is 1, the maximum value is 200</p>
                                    </li>
                                    <li><b>page_size</b> (optional)
                                    <p>
                                            The number of categories in the pages. If not specified, this defaults to 100. The
                                        minimum value is 5, the maximum value is 200</p>
                                    </li>
                                    <li><b>returnformat</b> (optional)
                                    <p>
                                            The returned object format. It can either be an XML or JSON (case insensitive). If not
                                    specified, the default return value is an XML</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Example response XML payload</h3>
                                <pre>
                                    &lt;Images&gt; <br />&emsp; &emsp;
                                &lt;Image id=&quot;1234567&quot; name=”dog” /&gt; <br />&emsp; &emsp;
                                &lt;Image id=&quot;1234568&quot; name=”cat” /&gt; <br />
                                    &lt;/Images&gt;
                                </pre>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Error codes</h3>
                                <ul>
                                    <li><b>-1 (General error)</b>
                                        <p>
                                            An internal error ocurred on the server. This is not dependent on the specific method
                                        or parameters passed. If the error persists, contact Thales.</p>
                                    </li>
                                    <li><b>1 (Invalid api_key)</b>
                                        <p>
                                            The <em>api_key</em> passed is not valid or is disabled. Check the key to make sure
                                        it is correct. If so, contact Thales.</p>
                                    </li>
                                    <li><b>2 (Invalid method)</b>
                                        <p>
                                            The method you attempted to call is invalid. Check the <em>method</em> parameter.</p>
                                    </li>
                                    <li><b>3 (No method specified)</b>
                                        <p>
                                            The required <em>method</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>4 (Invalid category)</b>
                                        <p>
                                            The category requested was not recognised or was not supplied.</p>
                                    </li>
                                    <li><b>6 (Invalid page_num)</b>
                                        <p>
                                            The page_num value was not recognised. The minimum value is 1, the maximum values
                                        is 200</p>
                                    </li>
                                    <li><b>7 (Invalid page_size)</b>
                                        <p>
                                            The page_size value was not recognised. The minimum value is 5, the maximum values
                                        is 200</p>
                                    </li>
                                    <li><b>9 (Invalid returnformat)</b>
                                        <p>
                                            The returnformat value was not recognized. It can either be
                                    XML or JSON (case insensitive)</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/galleryapi'>Back</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GetCategoryImageList;